import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { Content } from 'Components/legacy/sbcra/Content/Content';

import { RoundedSection } from '../../../../common/RoundedSection/RoundedSection';

import LocalTexts from './GlovesVideo.texts.json';

import styles from './GlovesVideo.scss';

const LocalT = new MDText(LocalTexts);

const link = <Hyperlink href='/blog/2026/06/25/driving-gloves-prize-draw' label={LocalT.translate('content.termsLink')} />;

export const GlovesVideo = () => <RoundedSection withBottomLedge withTopLedge>
  <Content className={styles.glovesVideo}>
    <h3 className={styles.title}>{LocalT.translate('title')}</h3>
    <div className={styles.content}>
      <div className={styles.videoContainer}>
        <iframe allowFullScreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" frameBorder="0" height="315" referrerPolicy="strict-origin-when-cross-origin" src="https://www.youtube.com/embed/6mvqHmOEQNI" title="YouTube video player" width="560"></iframe>
      </div>
      <div>
        <h4 className={styles.copyTitle}>{LocalT.translate('content.title')}</h4>
        <p>{LocalT.translate('content.para1')}</p>
        <p>{LocalT.translate('content.para2')}</p>
        <p>{LocalT.translate('content.para3')}</p>
        <p>{LocalT.translate('content.terms', { link })}</p>
      </div>
    </div>
  </Content>
</RoundedSection>;
